/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import type { UpdateGroupInput } from "~/generated/graphql";
import type { ResourceGroupData } from "../../ResourceGroupDetails/types";
import { ResourceGroupFields } from "./types";

export function mapResourceGroupToResourceGroupPutInput(
  resourceGroup?: Partial<ResourceGroupData>
): UpdateGroupInput {
  return {
    id: resourceGroup?.id ?? "",
  };
}

export function getUpdateObject(
  data: ResourceGroupFields | UpdateGroupInput,
  resourceGroup?: Partial<ResourceGroupData>
): UpdateGroupInput {
  const putResourceGroup =
    mapResourceGroupToResourceGroupPutInput(resourceGroup);

  return { ...putResourceGroup, ...data };
}
